import Color from '@bubble-dev/fantasy-color';
export default Color;
//# sourceMappingURL=Color.js.map